<template>
  <div class="notification">
    <v-base-card>
      <template v-slot:heading>
        お知らせ 一覧
      </template>

      <template v-slot:content>
        <v-row class="mb-0 pb-0">
          <v-col offset="9" cols="3" class="d-flex">
            <v-btn
              class="mt-5 ml-auto"
              small color="#4a81aa"
              dark
              @click.stop="$router.push('/admin/notification')"
            >
              新規作成
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="notifications"
          :loading="loading"
          loading-text="Loading... Please wait"
          :options.sync="pagination"
          :height="300"
          hide-default-footer
        >
          <template #[`item.filename`]="{ item }">
            <a @click.stop="download(item)" v-if="item.file_path">
              <v-icon small dark color="primary">
                mdi-file-send-outline
              </v-icon>{{item.filename}}
            </a>
          </template>
          <template #[`item.edit`]="{ item }">
            <v-btn icon @click.stop="edit(item)">
              <v-icon small dark>
                mdi-cog-outline
              </v-icon>
            </v-btn>
          </template>
          <template #[`item.delete`]="{ item }">
            <v-btn icon @click.stop="openDeleteConfirmDialog(item)">
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="pagination.page"
          :length="pages"
          color="secondary"
        />
      </template>
    </v-base-card>

    <v-confirm-dialog
      ref="confirm"
      title="お知らせ削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBaseCard,
    VConfirmDialog,
  },
  data () {
    return {
      headers: [
        { text: '件名', align: 'start', value: 'title' },
        { text: '表示開始日時', align: 'center', value: 'start_at' },
        { text: '表示終了日時', align: 'center', value: 'end_at'},
        { text: '登録日時', align: 'center', value: 'created_at'},
        { text: '添付ファイル', align: 'center', value: 'filename'},
        { text: '編集', align: 'center', value: 'edit', sortable: false },
        { text: '削除', align: 'center', value: 'delete', sortable: false },
      ],
      notifications: [],
      deletedNotification: {
        id: null,
        title: '',
      },
      loading: false,
      pagination: {
        itemsPerPage: 5
      },
    }
  },

  async mounted() {
    await this.getNotifications()
  },

  computed: {
    deleteMessage() {
      return `${this.deletedNotification.title} を削除します。よろしいですか。`
    },
    pages() {
      return this.pagination.itemsPerPage ? Math.ceil(this.notifications.length / this.pagination.itemsPerPage) : 0
    },
  },

  methods: {
    async download(notification){
      const res = await this.$axios(
        notification.file_path,
        {responseType: 'blob'}
      )
      const blob = new Blob([res.data], { type: res.data.type })

      saveAs(blob, notification.filename)
    },
    // 管理者_お知らせ一覧取得API
    async getNotifications() {
      this.loading = true
      const res = await this.$axios('/api/v1/admin/notifications')
      this.notifications = res.data
      this.loading = false
    },
    openDeleteConfirmDialog(notification) {
      this.deletedNotification = notification
      this.$refs.confirm.open()
    },
    // 管理者_お知らせ削除API
    async confirmDeletion() {
      const url = `api/v1/admin/notifications/${this.deletedNotification.id}`
      await this.$axios.delete(url)
      this.$toasted.global.success({
        message: `${this.deletedNotification.title}を削除しました`
      })
      this.getNotifications()
    },
    async edit(notification) {
      await this.$store.commit('notification/setNotification', notification)
      await this.$store.dispatch('notification/getAttached', {
        file_path: notification.file_path,
        filename: notification.filename,
      })
      this.$router.push('/admin/notification')
    },
    create() {
      this.$store.commit('notification/initialize')
      this.$router.push('/admin/notification')
    },
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;
</style>
